import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { IncludeNumber, IncludeUpper, SizeWithoutAccents } from '../../enums/regex';

@Component({
  selector: 'app-password-format',
  templateUrl: './password-format.component.html',
  styleUrls: ['./password-format.component.scss'],
})
export class PasswordFormatComponent implements OnInit, OnChanges {

  @Input() password = '';
  @Input() textColor ?= 'status-icon-enable';

  public isPasswordContain = { color: 'status-icon-enable', name: 'ellipse-sharp' };
  public capitalLetter = { color: 'status-icon-enable', name: 'ellipse-sharp' };
  public leastNumber = { color: 'status-icon-enable', name: 'ellipse-sharp' };

  constructor() { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('password')) {
      const { isPasswordContain, capitalLetter, leastNumber } = this.validatePassFormat(this.password);
      this.isPasswordContain = isPasswordContain;
      this.capitalLetter = capitalLetter;
      this.leastNumber = leastNumber;
    }
  }

  private validatePassFormat = (pass: string) => {
    let isPasswordContain = { color: this.textColor, name: 'ellipse-sharp' };
    let capitalLetter = { color: this.textColor, name: 'ellipse-sharp' };
    let leastNumber = { color: this.textColor, name: 'ellipse-sharp' };

    if (!(typeof pass === 'string' && pass.length > 0)) {
      isPasswordContain = { color: this.textColor, name: 'ellipse-sharp' };
      capitalLetter = { color: this.textColor, name: 'ellipse-sharp' };
      leastNumber = { color: this.textColor, name: 'ellipse-sharp' };
    } else if (pass.length > 7 && pass.length < 13) {
      isPasswordContain = SizeWithoutAccents.test(pass) ? { color: 'success', name: 'checkmark-success' }
        : { color: 'danger', name: 'close-circle' };

      capitalLetter = IncludeUpper.test(pass) ? { color: 'success', name: 'checkmark-success' }
        : { color: 'danger', name: 'close-circle' };

      leastNumber = IncludeNumber.test(pass) ? { color: 'success', name: 'checkmark-success' }
        : { color: 'danger', name: 'close-circle' };

    } else {
      isPasswordContain = SizeWithoutAccents.test(pass) ? { color: 'danger', name: 'close-circle' }
        : { color: 'danger', name: 'close-circle' };

      capitalLetter = IncludeUpper.test(pass) ? { color: 'success', name: 'checkmark-success' }
        : { color: 'danger', name: 'close-circle' };

      leastNumber = IncludeNumber.test(pass) ? { color: 'success', name: 'checkmark-success' }
        : { color: 'danger', name: 'close-circle' };

    }

    return { isPasswordContain, capitalLetter, leastNumber };
  }

}
